import angular from 'angular';
import onboardingDetails from './onboardingDetails';
import './style.scss';

export default angular
  .module('components.onboardingDetails', [])
  .component('onboardingDetails', onboardingDetails).name;
